import React, { useState } from "react";
import {
  Button,
  TextField,
  Stack,
  InputAdornment,
  Tooltip,
  CircularProgress,
  Box,
} from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { application } from "globals/endpoints";
import CTLNotification from "../CTLNotification";

const operationURLS = {
  upload: "/conferenceRoom/upload",
};

export default function FileUpload({ onFileChange }) {
  const [file, setFile] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
    pagename: "",
    status: "",
  });

  const handleSendClick = async () => {
    if (selectedFile) {
      setUploading(true);
      const formData = new FormData();
      formData.append("file", selectedFile);
      formData.append("type", "default");

      try {
        await application.post(operationURLS.upload, formData);
        setNotify({
          isOpen: true,
          status: "File uploaded successfully!",
          type: "success",
          pagename: "File Upload",
        });
      } catch (error) {
        setNotify({
          isOpen: true,
          message: "",
          type: "error",
          pagename: "File Upload",
          status: "File upload failed!",
        });
      } finally {
        setUploading(false);
      }
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setFile(file.name);
      setSelectedFile(file);
      if (onFileChange) onFileChange(file);
    }
  };

  return (
    <>
      <input
        type="file"
        accept=".wav"
        style={{ display: "none" }}
        onChange={handleFileChange}
        id="file-input"
      />
      <Stack direction="row" spacing={1}>
        <Tooltip title={file ? `${file}` : "Please Select the File"}>
          <TextField
            variant="outlined"
            label="Selected File"
            value={file}
            InputProps={{
              readOnly: true,
              endAdornment: (
                <InputAdornment position="end">
                  <label htmlFor="file-input" style={{ cursor: "pointer" }}>
                    <CloudUploadIcon style={{ color: "red" }} />
                  </label>
                </InputAdornment>
              ),
            }}
            fullWidth
          /> 
        </Tooltip>
        {file && 
        <Box sx={{ position: "relative", display: "inline-block" }}>
          <Button
            variant="contained"
            style={{ height: "45px", minWidth: "80px" }}
            color="primary"
            onClick={handleSendClick}
            disabled={!selectedFile}
          >
            {uploading ? (
              <>
                <span style={{ opacity: 0.5 }}>Upload File</span>
                <CircularProgress
                  size={20}
                  sx={{
                    color: "primary.contrastText",
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    marginTop: "-12px",
                    marginLeft: "-12px",
                    zIndex: 1,
                  }}
                />
              </>
            ) : (
              "Upload File"
            )}
          </Button>
        </Box>}
      </Stack>
      <CTLNotification notify={notify} setNotify={setNotify} />
    </>
  );
}
